import * as React from 'react';
import S from './Breadcrumbs.styles';
const Breadcrumbs = ({ theme = 'light', ...props }) => {
    return (React.createElement(S.Container, { "aria-label": "breadcrumb", "data-theme": theme },
        React.createElement(S.List, null, props.items.map((item, i) => (React.createElement(S.Item, { key: `breadcrumb-${i}` },
            React.createElement(S.ItemLink, { href: item.url, title: item.text, "aria-current": i === props.items.length - 1 ? 'location' : undefined }, item.text)))))));
};
export default Breadcrumbs;
